


import compras from './compras.routes'
import ventas from './ventas.routes'
import productos from './productos.routes'
import inventarios from './inventarios.routes'
import alertas from './alertas.routes'
import caja from './caja.routes'
import egresos from './egresos.routes'
import clientes from './clientes.routes'
import proveedores from './proveedores.routes'

export default [
  {
    path: '',
    name: 'pos.dashboard',
    component: () => import('@/views/pos/PosDashboard.vue'),
    meta: { sinCaja: true },
  },
  {
    path: 'consulta-precios',
    name: 'pos.consultaPrecios',
    component: () => import('@/views/pos/consulta/ConsultaPrecios.vue'),
    meta: { sinCaja: true },
  },
  {
    path: 'home',
    name: 'pos.home',
    component: () => import('@/views/pos/PosHome.vue'),
    meta: { sinCaja: true },
  },
      {
    path: 'sucursales',
    name: 'pos.seleccionarSucursal',

    component: () => import('@/views/pos/sucursal/SeleccionarSucursal.vue'),

    meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: false, showPosNav: false }

  },

  ...proveedores,
  ...clientes,
  ...compras,
  ...ventas,
  ...productos,
  ...inventarios,
  ...alertas,
  ...caja,
  ...egresos,
]

